import React, { Component } from 'react';
import FileSaver from 'file-saver'

import Button from '../components/Button.jsx'
import { createExcelBlob } from '../../lib/xlsx.js'

const data = [
  [1, 2, 3, 4], 
  [5, 6, 7, 8],
  ["价格包含项目"], 
  ["西班牙申根旅游签证办理费用"], 
  ["从国内搭乘飞机至巴黎"], 
  ["凯旋门+香榭丽大道"], 
  ["亚历山大三世大桥+罗浮宫"], 
  ["塞纳河"], 
  ["巴黎圣母院+埃菲尔铁塔"], 
  ["巴黎AYRE3星级起酒"], 
]

/**
 * 
 */
class ExcelTest extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      download: "LOL"
    }
  }

  render() {
    return (
      <div style={{padding: 50}}>
        <Button onClick={() => FileSaver.saveAs(createExcelBlob(data), "shit.xlsx")}>
          Crear un Excel con chorradas
        </Button>
      </div>
    )
  }
}

export default ExcelTest
